
import axios from "axios";
import Cookies from "js-cookie";

const params = new URLSearchParams(window.location.search);

export const iframeConfig = {
  username: params.get("username") || "",
  password: params.get("password") || "",
};

// API URLs
const LOGIN_BASE_URL =
  "https://onboarding.customers.bigfivecrm.com";

const API_BASE_URL =
  "https://dev.api.bigfivecrm.com";

const BASE_URL =
  "https://live.api.bigfivecrm.com";

// API endpoints
const LOGIN_URL = "/micaoi/login";
const GET_RECORDS_URL = "/api/v2/auth/get-records";
const AI_INTENTLIST_API = "/api/v2/auth/ai-intent";
const AI_EXECUTION_API = "/api/v2/auth/mica/execution";
const AI_ONESTEPBACK_API = "/api/v2/auth/mica/onestepback";
const AI_GetSessionInputs_API =
  "/api/v2/auth/mica/aiGetSessionInputs";

const KNOWLEDGE_BASE_API = "/api/v2/articles";
const LEAD_URL = "/api/v2/contact-us";

// Base URL helper
export const getBaseUrl = () => API_BASE_URL;

// Login Axios instance
export const loginAxiosInstance = axios.create({
  baseURL: LOGIN_BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// Main API Axios instance
export const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// Live CRM Axios instance
export const axioscrmInstance = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
       AuthToken: `Bearer b25ib2FyZGluZ2FwaUBiaWdmaXZlY3JtLmNvbTpzZXJpb3VzMjNhJCMkRkQqI0ZBT1NJREYjKCkqI1dIRkEpKFJVKSgjUUpGU0E=`,

  },
});

// Remove accessible cookies
const removeAllCookies = () => {
  Object.keys(Cookies.get()).forEach((cookie) => {
    Cookies.remove(cookie);
  });
};

// Login API
export const LoginAPI = async (data) => {
  try {
    const response = await loginAxiosInstance.post(
      LOGIN_URL,
      data
    );

    // The browser handles Set-Cookie automatically
    // when the server's cookie and CORS configuration permits it.
    return response.data;
  } catch (error) {
    console.error("Login failed:", error);
    throw error;
  }
};

// Get records API
export const GetRecordApi = async (data) => {
  try {
    const response = await axiosInstance.post(
      GET_RECORDS_URL,
      data
    );

    return response.data;
  } catch (error) {
    console.error("Get record failed:", error);

    const message = error.response?.data?.message;

    if (
      message === "Unauthenticated! Please Login" ||
      message === "Session Expired"
    ) {
      removeAllCookies();
    }

    throw error;
  }
};

// AI One Step Back API
export const AIOneStepBackAPI = async (data) => {
  try {
    const response = await axiosInstance.post(
      AI_ONESTEPBACK_API,
      data
    );

    return response.data;
  } catch (error) {
    console.error("One step back failed:", error);
    throw error;
  }
};

// AI Get Session Inputs API
export const AIGetSessionInputs = async (data) => {
  try {
    const response = await axiosInstance.post(
      AI_GetSessionInputs_API,
      data
    );

    return response.data;
  } catch (error) {
    console.error("Get session inputs failed:", error);
    throw error;
  }
};

// AI Intent List API
export const AIIntentListAPI = async (data) => {
  try {
    const response = await axiosInstance.post(
      AI_INTENTLIST_API,
      data,
      
    );

    return response.data;
  } catch (error) {
    console.error("Intent list failed:", error);
    throw error;
  }
};

// AI Execution API
export const AIExecutionAPI = async (data) => {
  try {
    const response = await axiosInstance.post(
      AI_EXECUTION_API,
      data
    );

    return response.data;
  } catch (error) {
    console.error("Execution failed:", error);
    throw error;
  }
};

// Knowledge Base API
export const KnowledgeBaseApi = async (data) => {
  try {
    const response = await axioscrmInstance.post(
      KNOWLEDGE_BASE_API,
      data
    );

    return response.data;
  } catch (error) {
    console.error("Knowledge base request failed:", error);
    throw error;
  }
};

// Submit Contact Form API
export const submitFormAPI = async (data) => {
  try {
    const response = await axios.post(
      `${BASE_URL}${LEAD_URL}`,
      data,
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Contact form submission failed:", error);
    throw error;
  }
};